import { faFileExcel, faFilePdf } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'

import { URL_BACKEND } from '../../../middleware/konstanter'

import filtype from './rapportconfig/filtype'

import './lastNedRapport.css'

const LastNedRapport = ({ rapportConfig, ar, fylke, kommune }) => {
    const lagNedlastingsLenke = (filtypeTekniskNavn, filtypeVisningsnavn, ikon) => {
        const { tekniskNavn, visningsnavn } = rapportConfig

        return (
            <a
                className="editorial-link"
                href="#"
                onClick={() => {
                    window.location = `${URL_BACKEND}/standardrapport/hent/${filtypeTekniskNavn}/${tekniskNavn}/${ar}/${fylke}/${kommune}`
                }}
            >
                Last ned {visningsnavn} som {filtypeVisningsnavn}
                &nbsp;
                <FontAwesomeIcon icon={ikon} />
            </a>
        )
    }

    return (
        <ul className="nedlastingslenke__liste">
            {rapportConfig.filtyper.includes(filtype.pdf) && <li>{lagNedlastingsLenke(filtype.pdf, 'PDF', faFilePdf)}</li>}
            {rapportConfig.filtyper.includes(filtype.xlsx) && (
                <li>{lagNedlastingsLenke(filtype.xlsx, 'Excel-dokument', faFileExcel)}</li>
            )}
        </ul>
    )
}

LastNedRapport.propTypes = {
    rapportConfig: PropTypes.object.isRequired,
    ar: PropTypes.string.isRequired,
    fylke: PropTypes.string.isRequired,
    kommune: PropTypes.string.isRequired
}

export default LastNedRapport
